import { useMutation } from '@tanstack/react-query'

import { EnvelopError } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'

interface MutationVariables {
    body: FormData
}

export function useContactUs() {
    return useMutation<unknown, [EnvelopError], MutationVariables>({
        mutationFn: ({ body }) =>
            fetchRequest({
                method: 'POST',
                serviceName: 'pam',
                endpoint: `/contact-us`,
                body,
                isBodyFormData: true,
            }),
    })
}
